export const FIREBASE_CONFIG = {
    apiKey: "AIzaSyCQ0zzPDw4rqqIHxVa3nNJSJpdvJR6JLEY",
    authDomain: "re-cognition.firebaseapp.com",
    projectId: "re-cognition",
    storageBucket: "re-cognition.appspot.com",
    messagingSenderId: "86263761360",
    appId: "1:86263761360:web:5995b487b7d253b34091d5",
    measurementId: "G-ES0FMRP32L"
}